/**************************************************
 * Nombre:       Formulario_Soporte
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {Flag, Title} from "@mui/icons-material";
import {useEffect, useState} from "react";
import IngresoImagen from "../../Modulo_formularios/Componentes/IngresoImagen";
import Zoom from "react-medium-image-zoom";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {ESTADOSOPORTE} from "../../Constantes";

const Formulario_Soporte = ({...props}) => {
    const [datos, setDatos] = useState({});


    useEffect(() => {

        let datos = props.props.getValues()
        if (datos) {
            setDatos(datos)
        }


    }, [props.props.watch])
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={6}>
                    <IngresoSelect Icono={Flag} nombre={'Estado'} dato={'estado'} {...props}
                                   requerido={'Campo Requerido'} opciones={ESTADOSOPORTE.map((it) => it.nombre)}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={Title} nombre={'Titulo'} dato={'nombre'} {...props}
                                  requerido={'Campo Requerido'}
                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={8} nombre={'Mensaje'} dato={'mensaje'} {...props}
                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography>Evidencias</Typography>
                </Grid>

                <Grid container size={12}>
                    <Zoom>
                        <img
                            src={datos.img}
                            width="100%"
                        />
                    </Zoom>
                </Grid>


                {datos.id &&
                    <>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Typography>Respuesta del Admin</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}}>
                            <IngresoTexto lineas={8} nombre={'Respuesta del Admin'} dato={'respuesta'} {...props}
                            />
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}}>
                            <IngresoImagen dato={'imgAdmin'} {...props} ancho={1} alto={1}/>
                        </Grid>

                    </>
                }


            </Grid>

        </form>

    )

}
export default Formulario_Soporte